<template lang="html">

  <div data="documentacion" class="cv-part">
    <h2 @click="openedit" class="title" :edit="showedit" :empty="!!!info">Documentación</h2>
    <template v-if="!!info">
      <div class="edit-options -one" :edit="showedit" v-for="doc in info" v-if="info.length != 0">
        <button class="eliminar" @click="eraseDoc(doc.id)">✕</button>
        <p :edit="showedit">
          <a :href="doc.enlace" target="_blank" rel="noopener noreferrer">
            {{(!!doc.nombre) ? doc.nombre : dominios.tipoDoc[doc.tipo]}}
          </a>
        </p>
      </div>
    </template>
    <template v-if="!!!info || info.length == 0">
      <p>Aún no tienes documentos añadidos, pulsa en añadir documento para añadirlo</p>
    </template>
    <button class="btn skull" @click="openadd">+ Añadir documentación</button>

    <div class="cover-popup row-center" v-if="showadd">
      <div class="popup">
        <a class="close" @click="showadd = false">✕</a>
        <h2 class="title-pop">Añadir documentacion</h2>

        <select v-model="doc.tipo" name="tipodocumento" v-validate="'required'">
          <option value="">Selecciona un tipo</option>
          <option v-for="doc in docs" :value="doc[0]">{{doc[1]}}</option>
        </select>
        <span class="error animated shake" v-if="errors.has('tipodocumento')">{{ errors.first('tipodocumento') }}</span>

        <input type="text" name="nombredoc" placeholder="Indica el nombre del documento" v-if="doc.tipo == '10'"
          v-model="doc.nombre" v-validate="'required'">
        <span class="error animated shake" v-if="errors.has('nombredoc')">{{ errors.first('nombredoc') }}</span>

        <div class="dropzone column-center" :error="errors.has('docfile')"
          :attached="attached && !errors.has('docfile')">
          <input type="file" @change="handleFileUpload($event)"
            v-validate="`size:1500|mimes:${formatosPermitidos}|required`" name="docfile">
          <template v-if="!attached">
            <img src="@/assets/img/file.svg" alt="Subir archivo">
            <p>Haz click o arrastra el archivo para añadirlo.<br>Peso máximo 1.5MB. Preferentemente archivos en formato PDF</p>
          </template>
          <template v-if="attached && !errors.has('docfile')">
            <img src="@/assets/img/tick.svg" alt="Subir archivo">
            <p>Archivo adjunto, pulse añadir para subirlo</p>
          </template>
          <template v-if="attached && errors.has('docfile')">
            <img src="@/assets/img/cancel.svg" alt="Subir archivo">
            <span class="error animated shake" v-if="errors.has('docfile')">{{ errors.first('docfile') }}</span>
          </template>
        </div>

        <button class="btn" @click="savedoc" :loading="loading">Añadir</button>
      </div>
    </div>

  </div>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  import { Validator } from "vee-validate";

  Vue.use(VeeValidate);

  export default {
    name: 'documentacion',
    props: ['info','infoPersonal'],
    data() {
      return {
        showadd: false,
        showedit : false,
        attached: false,
        loading: false,
        doc: {
          tipo: '',
          nombre: '',
          ficheroB64ParaAltas: '',
          extension_adjunto: ''
        },
        formatosPermitidos: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'application/msword', 'application/vnd.oasis.opendocument.text', 'application/vnd.ms-powerpoint', 'application/vnd.oasis.opendocument.presentation', 'application/vnd.ms-excel', 'vnd.ms-excel', 'image/*', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'image/jpg', 'image/jpeg', 'image/png'],
        relacionFormato: {
          'vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
          'vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
          'pdf': 'pdf',
          'msword': 'doc',
          'vnd.oasis.opendocument.text': 'odt',
          'vnd.ms-powerpoint': 'ppt',
          'vnd.oasis.opendocument.presentation': 'odp',
          'vnd.ms-excel': 'csv',
          'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
          'msword': 'doc'
        }
      }
    },
    computed: {
      ...mapGetters({
        dominios: 'getDominios'
      }),
      docs() {
        if (!!this.dominios) {
          let tipos = Object.entries(this.dominios.tipodocsubida);
          if (!!this.infoPersonal && this.infoPersonal.idSede != 3) {
            tipos = tipos.filter(([key]) => key !== '16');
          }
          return tipos.sort(function (p1, p2) {
            return (p1[1] < p2[1]) ? -1 : 1;
          });
        }
      }
    },
    methods: {
      ...mapActions(['addDoc', 'eraseDoc','canEditCv']),
      openadd(){
        this.showadd = true;
      },
      openedit() {
        if(!!!this.info){
          this.showadd = true;
        }else{
          this.showedit = !this.showedit;
        }
      },
      handleFileUpload() {

        let file = event.target.files[0];

        let type = file.type.split("/")[1];
        this.doc.extension_adjunto = (!!this.relacionFormato[type]) ? this.relacionFormato[type] : type;

        this.getBase64(file).then(data => {
          this.doc.ficheroB64ParaAltas = data;
          this.attached = true;
        });

      },
      getBase64: function (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      },
      savedoc() {
        this.$validator.validateAll().then(canSend => {
          if (canSend) {
            this.loading = true;
            let doc = JSON.parse(JSON.stringify(this.doc));
            this.addDoc(doc).then(r => {
              this.loading = false;
              this.reset();
            }).catch(() =>{
              this.loading = false;
            });
          }
        });
      },
      reset() {
        this.showadd = false;
        this.attached = false;
        this.doc = {
          tipo: '',
          nombre: '',
          ficheroB64ParaAltas: '',
          extension_adjunto: ''
        };
      }
    },
    watch : {
      'showadd'(){
        if(!this.showadd){
          this.reset();
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  select {
    margin-bottom: 20px;

    &[aria-invalid=true] {
      margin-bottom: 0;
    }
  }

  input {
    width: 100%;
    margin-bottom: 20px;

    &[aria-invalid=true] {
      margin-bottom: 0;
    }
  }

  p a{
    width: auto;;
  }

</style>


// WEBPACK FOOTER //
// src/components/views/mi-cv/documentacion.vue